// extracted by mini-css-extract-plugin
export default {"details_container":"DetailsContainer_details_container__nVrEx","titleBar":"DetailsContainer_titleBar__-Z5t2"};